"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vipOrderUrls = void 0;
/* istanbul ignore file -- just a list of URLs */
const vipOrderUrls = exports.vipOrderUrls = {
  access: '/system/ajax/stickybar/VipAccessJson',
  accessConsultant: consultantNumber => `/system/ajax/VipShopping/AccessConsultant?consultantNumber=${consultantNumber}`,
  accessSwitch: consultantNumber => `/system/ajax/StickyBar/VipAccessSwitch?ConsultantNumber=${consultantNumber}`,
  accessSwitchValidate: consultantNumber => `/system/ajax/StickyBar/VipAccessSwitchValidate?ajaxId=69&related%5BConsultantNumber%5D=${consultantNumber}&activeInput=ConsultantNumber&ConsultantNumber=${consultantNumber}`,
  basket: '/shopping/basket',
  consultantNumbers: hint => `/system/ajax/VipShopping/GetConsultantNumbers?hint=${hint}`
};
